import { Button } from '@consigli/facade';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { type GroupByOption } from './action-item-types';

interface ActionItemsGroupSelectorProps {
  groupBy: GroupByOption;
  onGroupByChange: (groupBy: GroupByOption) => void;
}

export const ActionItemsGroupSelector: FC<ActionItemsGroupSelectorProps> = ({
  groupBy,
  onGroupByChange,
}) => {
  const { t } = useTranslation();

  const groupByOptions: { key: GroupByOption; label: string }[] = [
    { key: 'person', label: t('meeting-secretary.action-items.group-by-person') },
    { key: 'topic', label: t('meeting-secretary.action-items.group-by-topic') },
    { key: 'deadline', label: t('meeting-secretary.action-items.group-by-deadline') },
    { key: 'status', label: t('meeting-secretary.action-items.group-by-status') },
    { key: 'meeting', label: t('meeting-secretary.action-items.group-by-meeting') },
  ];

  return (
    <div className="mb-6 flex items-center gap-2">
      <span className="text-sm font-semibold text-gray-700">
        {t('meeting-secretary.action-items.group-by')}:
      </span>
      <div className="flex flex-wrap gap-1">
        {groupByOptions.map((option) => (
          <Button
            key={option.key}
            secondary
            rounded
            onClick={() => onGroupByChange(option.key)}
            className={`!px-3 !py-1 !text-sm !font-medium !border-0 ${
              groupBy === option.key
                ? '!bg-[#475569] !text-white'
                : '!bg-gray-100 !text-gray-600 hover:!text-gray-900'
            }`}
          >
            {option.label}
          </Button>
        ))}
      </div>
    </div>
  );
};
